var _styled;

import styled from 'react-emotion';
import React from 'react';
import PropTypes from 'prop-types';
import { BLACK } from 'govuk-colours';
import { withWhiteSpace } from '@govuk-react/hoc';
import { FONT_SIZE, LINE_HEIGHT, MEDIA_QUERIES, NTA_LIGHT } from '@govuk-react/constants';
var StyledLabelText = styled('span')((_styled = {
  fontFamily: NTA_LIGHT,
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale',
  display: 'block',
  clear: 'none',
  fontWeight: 400,
  fontSize: FONT_SIZE.SIZE_16,
  lineHeight: LINE_HEIGHT.SIZE_16
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  fontSize: FONT_SIZE.SIZE_19,
  lineHeight: LINE_HEIGHT.SIZE_19
}, _styled.color = "" + BLACK, _styled.paddingBottom = '2px', _styled), function (_ref) {
  var error = _ref.error;
  return {
    fontWeight: error ? 700 : undefined
  };
});
/**
 *
 * ### Usage
 *
 * Simple
 * ```jsx
 * <LabelText>Example</LabelText>
 * ```
 *
 * ### References:
 * - https://github.com/alphagov/govuk-frontend/tree/master/src/components/
 *
 */

var LabelText = function LabelText(props) {
  return React.createElement(StyledLabelText, props);
};

export default withWhiteSpace({
  marginBottom: 0
})(LabelText);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/label-text/es/index.js
// module id = 13
// module chunks = 0